 <div class="row stepper-bg d-flex flex-row justify-content-center">
   <div class="stepper-wrapper">
     <div class="d-flex flex-column align-items-center step-item" *ngFor="let step of steps; let i = index"
          [class.faded]="activeStep !== i">
       <div class="step text-color-1 accent-bg cursor-pointer" (click)="changeStep(i)">
         {{i + 1}}
       </div>
       <span *ngIf="!localize" class="font-600 small-subtitle">{{step.title}}</span>
       <span *ngIf="localize" class="font-600 small-subtitle">{{step.title | dictionary}}</span>
     </div>
   </div>
 </div>
